import { OtpInput } from 'react-native-otp-entry'
import {
  type SegmentAction,
  type SegmentComponent,
  triggerSegmentAction,
} from '@/src/services/segment'
import { fontFamilies, mesaColorNames } from '@/src/common/theme'
import type { ComponentProps } from 'react'
import { buttonMaxWidth } from '@/src/common/components/Button'

interface OtpInputPropsInterface extends ComponentProps<typeof OtpInput> {
  segmentTrack?: boolean
  segmentAction: SegmentAction
  segmentComponent?: SegmentComponent
}

export function InputCode({
  segmentAction,
  segmentComponent = 'Input',
  segmentTrack = true,
  ...otherProps
}: OtpInputPropsInterface) {
  return (
    <OtpInput
      autoFocus={false}
      hideStick
      focusColor={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']}
      {...otherProps}
      onFilled={(text) => {
        otherProps.onFilled?.(text)

        if (segmentTrack) {
          void triggerSegmentAction({
            component: segmentComponent,
            action: segmentAction,
          })
        }
      }}
      theme={{
        inputsContainerStyle: {
          gap: 12,
          width: buttonMaxWidth,
          minWidth: buttonMaxWidth,
          maxWidth: buttonMaxWidth,
        },
        pinCodeContainerStyle: {
          borderRadius: 50,
          width: 48,
          height: 48,
        },
        pinCodeTextStyle: {
          fontFamily: fontFamilies['PlusJakartaSans-Regular'],
          fontWeight: 400,
          fontSize: 16,
          color: mesaColorNames['Greyscale/900 #152438'],
        },
      }}
      textInputProps={{
        accessibilityLabel: 'One-Time Password',
        ...otherProps.textInputProps,
      }}
    />
  )
}

export default InputCode
